import { DragNDropIcon } from "../../components/icons/Icon";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import styles from "./Invoice.module.css";
import { useEffect, useRef, useState } from "react";

const PDFUpload = ({
  mode,
  pdfFile,
  setPdfFile,
  onFileChange,
  viewOnly = false,
  focus = false,
}) => {
  const { show } = useToast();
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === "dragenter" || e.type === "dragover");
  };

  const validateFileType = (file) => {
    return file.type === "application/pdf";
  };

  const handleChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && validateFileType(file)) {
      setPdfFile(file);
      onFileChange && onFileChange(file);
    } else {
      show("Please upload a valid PDF file.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && validateFileType(file)) {
      setPdfFile(file);
      onFileChange && onFileChange(file);
    } else {
      show("Please upload a valid PDF file.");
    }
  };

  const onButtonClick = () => inputRef.current.click();

  const handleViewPDF = () => {
    if (pdfFile) {
      const pdfUrl =
        pdfFile instanceof File || pdfFile instanceof Blob
          ? URL.createObjectURL(pdfFile)
          : process.env.REACT_APP_S3URL + pdfFile;

      window.open(
        pdfUrl,
        "PDFViewer",
        "width=800,height=600,scrollbars=yes,resizable=yes"
      );
    }
  };

  const handleDelete = () => {
    setPdfFile(null);
    onFileChange && onFileChange(null);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (
        focus &&
        (event.key === " " || event.code === "Space" || event.keyCode === 32)
      ) {
        onButtonClick();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [focus]);

  return (
    <>
      <div
        className={`${styles.pdf_upload} ${focus ? styles.focused : ""}`}
        style={
          mode ? { backgroundColor: "#1B1D21", borderColor: "#1B1D21" } : {}
        }
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={() => {
          if (pdfFile) {
            handleViewPDF();
          } else {
            onButtonClick();
          }
        }}
      >
        <div className={styles.pdf_upload_text}>
          {pdfFile ? (
            <p style={{ color: mode ? "#fff" : "#000" }}>
              {pdfFile.name || pdfFile}
            </p>
          ) : (
            <>
              <DragNDropIcon />
              <p>
                Drag & Drop <br /> a PDF file
              </p>
              <p style={mode ? { color: "#fff" } : {}}>
                or <span>browse files</span> on your computer
              </p>
              <input
                type="file"
                accept="application/pdf"
                style={{ display: "none" }}
                ref={inputRef}
                onChange={handleChange}
              />
              {dragActive && (
                <div
                  className={styles.drag_overlay}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                ></div>
              )}
            </>
          )}
        </div>
      </div>

      <div
        className={`${styles.pdf_upload_footer} ${focus ? styles.focused : ""}`}
      >
        {pdfFile && !viewOnly ? (
          <div className={styles.delete}>
            <span onClick={handleDelete}>Delete</span>
          </div>
        ) : (
          <div>
            <span style={{ visibility: "hidden" }}>FOR HEIGHT</span>
          </div>
        )}
      </div>
    </>
  );
};

export default PDFUpload;
